import { render, staticRenderFns } from "./RanksAndRewards.vue?vue&type=template&id=6aea4f02&scoped=true&"
import script from "./RanksAndRewards.vue?vue&type=script&lang=js&"
export * from "./RanksAndRewards.vue?vue&type=script&lang=js&"
import style0 from "./RanksAndRewards.vue?vue&type=style&index=0&id=6aea4f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea4f02",
  null
  
)

export default component.exports